<!--
 * @Author: your name
 * @Date: 2021-04-22 11:29:07
 * @LastEditTime: 2021-05-21 14:07:43
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /youhuaguo-ui/src/views/officialSeal/index.vue
-->
<template>
  <div>
    <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSearch" v-model="formInline.nameOrCode" placeholder="品牌合同名称/编号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSearch" v-model="formInline.brandName" placeholder="合作品牌"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input clearable @keyup.enter.native="onSearch" v-model="formInline.startApplyUserName" placeholder="合同创建人"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select clearable v-model="formInline.projectType" placeholder="未选择项目类型">
          <el-option label="代运营" :value="1"></el-option>
          <el-option label="媒介" :value="2"></el-option>
          <el-option label="Campaign" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
    </el-form>
    <div style="padding-bottom:20px;">品牌合同总数：{{total}}条</div>
    <el-table v-loading="loading" size="small" :data="tableData" style="width: 100%">
      <el-table-column align="center" prop="date" label="品牌合同名称">
        <template slot-scope="scope">
          <div>{{scope.row.name}}</div>
          <div>{{scope.row.ourCode}}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="money" label="合同金额"></el-table-column>
      <el-table-column align="center" prop="address" label="项目类型">
        <template slot-scope="scope">
          <div>
            {{projectTypeList[scope.row.projectType]}}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="brandName" label="合作品牌"></el-table-column>
      <el-table-column align="center" prop="signSubject" label="签约主体"></el-table-column>
      <el-table-column align="center" prop="fileList" label="品牌合同文件">
         <template slot-scope="scope">
          <filePreview :fileList="scope.row.fileList"></filePreview>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="startApplyUserName" label="创建人"> </el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
      <el-table-column v-if="brandType === 'has'" align="center" prop="startAuditTime" label="审批时间"></el-table-column>
      <el-table-column align="center" prop="startAuditStatus" label="审批状态">
        <template slot-scope="scope">
          <div>
            {{StartApprovalStatusList[scope.row.startAuditStatus]}}
          </div>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="date" label="操作" width="200">
        <template slot-scope="scope">
          <el-button size="small" v-if="brandType === 'has'" type="text" @click="detailsClick(scope.row.id)">查看</el-button>
          <el-button size="small" v-else type="text" @click="approvalClick(scope.row.id)">审批</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div style="text-align:right;">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="formInline.pageNum"
        :page-sizes="[10, 20, 30, 40, 50, 100]"
        :page-size="formInline.pageSize"
        layout="sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { brandContractStartPage } from '@/api/approve/brand';
export default {
  props:['brandType'],
  components: {
  },
  data() {
    return {
      loading:false,
      projectTypeList:['','代运营','媒介','Campaign'],
      StartApprovalStatusList:['','待直属上级审批','直属上级审批不通过','直属上级审批通过'],//启动审批状态
      formInline: {
        auditFlag:this._props.brandType=='stay'?0:1,
        brandName:"",
        nameOrCode:"",
        projectType:"",
        startApplyUserName:"",
        pageNum: 1,
        pageSize: 10,
      },
      tableData:[],
      total:0,
    };
  },
  mounted() {
    this.getDataInit()
  },
  methods: {
    //列表数据查询
    getDataInit(){
      this.loading = true;
      brandContractStartPage(this.formInline).then((res) => {
        this.tableData = res.data;
        this.total = res.total;
        this.loading = false;
      })
    },
    //查询
    onSearch(){
      this.formInline.pageNum = 1;
      this.getDataInit()
    },
    //查看
    detailsClick(id){
      let router = this.$router.push({
        path: `/check/contractApproval`,
        query: {id,value:'contractStart',type:1},
      });
      window.open(router.href);
      window.open("about:blank","_self").close()
    },
    //审批
    approvalClick(id){
      let router = this.$router.push({
        path: `/check/contractApproval`,
        query: {id,value:'contractStart'},
      });
      window.open(router.href);
      window.open("about:blank","_self").close()
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.getDataInit()
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val;
      this.getDataInit()
    }
  },
};
</script>
<style lang="scss" scoped>
.details-top{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.invoiceList {
  display: flex;
  justify-content: space-between;
}
.mt-10 {
  margin-top: 10px;
}

/deep/.el-dialog__header {
  border-bottom: 1px solid #ccc !important;
}

/deep/.select-input-wrap-s {
  .el-input-group__append {
    position: relative;
    width: 35px;
    height: 35px;
    border: none;
    background: #fff;
    padding: 0;
    color: #409eff;
    .iconfont {
      position: absolute;
      top: -2px;
      font-size: 36px !important;
    }
    cursor: pointer;
  }
}
/deep/.select-tag {
  .el-tag__close{
    top: -8px;
  }
}
</style>